import HttpClient from "@lib/http-client";

/**
 * @memberof Services
 */
class EventService extends HttpClient {
  async trackViewEvent(id) {
    return this.http.get(`/events/${id}/view`);
  }

  async trackEvent(id, type, fields) {
    return this.http.post(`/events/${id}/event`, { ...fields, type });
  }
}

export default EventService;
